import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { SseService } from './sse.service';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class FeederService {

  constructor(private _zone: NgZone, private _sseService: SseService, private http: HttpClient) { }

  getServerSentEvent(url): Observable<any> {
    return Observable.create((observer) => {
      const es = this._sseService.getEventSource(url);
      es.onmessage = (event) => {
        this._zone.run(() => observer.next(event));
      };
      es.onerror = (error) => {
        observer.error(error);
      };
    });
  }

  getFeeders(body){
    return this.http.post(`getFeeders`, body);
  }

  getFeederData(body){
    return this.http.post('getFeederData', body);
  }

  getFeederTileData(body){
    return this.http.post('getFeederTileData', body);
  }

  getFeederAlertParamStatus(body){
    return this.http.post('getFeederAlertParamStatus', body);
  }

  getFeederManagerInfo(body){
    return this.http.post('getFeederManagerInfo', body);
  }

  getAlertFeederReport(body){
    return this.http.post('getAlertFeederReport',body)
  }
  
  getFeederPopupTileData(body){
    return this.http.post('getFeederPopupTileData', body);
  }

  getFeederAlertTileData(body){
    return this.http.post('getFeederAlertTileData', body);
  }

  addUpdateFeeder(body){
    return this.http.post('addUpdateFeeder',body);
  }

  getFeederDetails(body){
    return this.http.post('getFeederDetails', body);
  }

  
}
